import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from './MainLayout';

const Sitemap = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

        // Override global html/body overflow-hidden for this page
        document.documentElement.style.overflow = 'auto';
        document.body.style.overflow = 'auto';

        return () => {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        };
    }, []);

    const links = [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/about' },
        { name: 'How to Buy Bits', path: '/howtobuybits' },
        { name: 'FAQ', path: '/faq' },
        { name: 'Journal', path: '/journal' },
        { name: 'Bits A-Z', path: '/bitsA-Z' },
        { name: 'News Articles', path: '/news-articles' },
        { name: 'Testimonial', path: '/testimonial' },
        { name: 'Contact', path: '/contact' },
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Terms & Conditions', path: '/terms' },
    ];

    return (
        <MainLayout>
            <div className="h-screen overflow-y-auto scrollStyle bg-darkGradient bg-cover bg-center text-white font-outfit pt-[120px] md:pt-[150px]">
                <main className="container pb-20 relative z-10">
                    <div className="max-w-[1200px] mx-auto">
                        <h1 className="text-skyblue text-4xl md:text-6xl font-jost font-semibold mb-6">
                            Sitemap
                        </h1>
                        <p className="text-white/60 text-lg md:text-xl mb-12 max-w-2xl">
                            Discover all that MyBitOfIt has to offer. Quick links to our guides, articles, and more.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
                            {links.map((link) => (
                                <Link
                                    key={link.path}
                                    to={link.path}
                                    className="group relative p-6 rounded-10px border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-all duration-300"
                                >
                                    <div className="absolute inset-0 border-marketing opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-10px" />
                                    <h3 className="text-xl md:text-2xl font-jost font-medium text-white group-hover:text-skyblue group-hover:rounded-10px transition-colors duration-300">
                                        {link.name}
                                    </h3>
                                    <div className="mt-4 flex items-center text-skyblue/60 text-sm font-medium group-hover:text-skyblue transition-colors duration-300">
                                        Explore
                                        <svg className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                        </svg>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </main>

                <div className="fixed bottom-0 left-0 w-full h-[300px] bg-gradient-to-t from-black/50 to-transparent pointer-events-none -z-0" />
            </div>
        </MainLayout>
    );
};

export default Sitemap;